import { TriangleAlert } from "lucide-react";

import { useBudgetRestricted } from "../hooks/useBudgetRestricted";

interface BudgetTopBannerProps {
  message?: string;
}

export const BudgetTopBanner = ({
  message = "New queries are paused until your admin increases the limit.",
}: BudgetTopBannerProps) => (
  <div className="absolute left-0 right-0 top-0 z-50 flex w-full items-center justify-between gap-4 border-b border-amber-300 bg-gradient-to-r from-amber-50 via-yellow-50 to-amber-100 px-4 py-2.5 dark:border-amber-700 dark:from-amber-950/40 dark:via-amber-900/30 dark:to-amber-950/40">
    <div className="flex min-w-0 items-center gap-2.5">
      <TriangleAlert className="h-4 w-4 shrink-0 text-amber-600 dark:text-amber-400" />
      <p className="text-sm font-medium text-amber-900 dark:text-amber-200">
        <strong className="font-semibold">Budget limit reached.</strong>{" "}
        {message}
      </p>
    </div>
    <span className="shrink-0 rounded-full bg-amber-500 px-2.5 py-0.5 text-xs font-bold text-white dark:bg-amber-600">
      Limit Reached
    </span>
  </div>
);

export const BudgetBanner = ({ message }: BudgetTopBannerProps) => {
  const { isRestricted } = useBudgetRestricted();
  if (!isRestricted) return null;
  return <BudgetTopBanner message={message} />;
};
